import { render, staticRenderFns } from "./PatientCardPharmacy.vue?vue&type=template&id=13512fcc"
import script from "./PatientCardPharmacy.vue?vue&type=script&lang=js"
export * from "./PatientCardPharmacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports